import React, { useMemo } from "react";
import { Box, Card } from "@chaser/components";
import { Users } from "lucide-react";
import { getIncludedUsersByModuleBreakdown } from "../viewHelpers";
import styles from "../Addons.module.scss";

const IncludedByPlanTable = ({ includedUsersByPlan = [] }) => {
  const { orderedModuleEntries, includedUsersTotal, unlimitedLimit } = useMemo(
    () => getIncludedUsersByModuleBreakdown(includedUsersByPlan),
    [includedUsersByPlan],
  );

  return (
    <Card p="none">
      <Box p="small">
        <table className={styles.includedByPlanTable}>
          <thead>
            <tr>
              <th className={styles.includedByPlanTableHeadCell}>Module</th>
              <th
                className={`${styles.includedByPlanTableHeadCell} ${styles.includedByPlanTableHeadCellRight}`}
              >
                Included
              </th>
            </tr>
          </thead>
          <tbody>
            {orderedModuleEntries.map(([moduleName, includedUsers]) => {
              const displayModuleName =
                moduleName === "Organisation add-ons" ? "By default" : moduleName;
              const isUnlimited = Number(includedUsers) >= unlimitedLimit;

              return (
                <tr key={moduleName}>
                  <td className={styles.includedByPlanTableCell}>
                    <span className={styles.includedPlanEntryIcon}>
                      <Users size={12} color="#5C6E83" strokeWidth={2} />
                    </span>
                    <span className={styles.includedPlanBreakdownName}>
                      {displayModuleName}
                    </span>
                  </td>
                  <td
                    className={`${styles.includedByPlanTableCell} ${styles.includedByPlanTableCellRight} ${styles.includedPlanBreakdownValue} ${isUnlimited ? styles.includedPlanValueUnlimited : ""}`}
                  >
                    {isUnlimited ? "Unlimited" : includedUsers}
                  </td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <th className={styles.includedPlanTotalLabel}>Total</th>
              <th
                className={`${styles.includedPlanTotalValue} ${styles.includedByPlanTableCellRight}`}
              >
                {includedUsersTotal >= unlimitedLimit
                  ? "Unlimited"
                  : includedUsersTotal}
              </th>
            </tr>
          </tfoot>
        </table>
      </Box>
    </Card>
  );
};

export default IncludedByPlanTable;
